import EventsAMAPage from './EventsAMAPage'

export default EventsAMAPage
// eslint-disable-next-line import/export
export * from './EventsAMAPage'
